import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map, switchMap, take, takeUntil } from 'rxjs/operators';
import { AuthService } from '@modules/auth';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmEmailComponent implements OnInit, OnDestroy {
  emailConfirmationParams$ = this.route.queryParams.pipe(
    map(({userId, code}) => ({userId, code})),
    filter(({userId, code}) => Boolean(userId && code)),
  );

  private readonly destroy$ = new Subject();

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService,
    private toasterService: ToastrService,
  ) {
  }

  ngOnInit(): void {
    this.emailConfirmationParams$.pipe(
      take(1),
      switchMap(({userId, code}) => this.authService.confirmEmail({userId, code})),
      takeUntil(this.destroy$)
    ).subscribe({
      next: () => {
        this.toasterService.success('Email confirmed! Please log in with your credentials.');
        this.router.navigate(['auth']);
      },
      error: () => {
        this.toasterService.error('Email confirmation failed, please try again.');
        this.router.navigate(['auth']);
      },
      complete: () => {
        console.warn('confirmation complete');
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }
}
